module.exports = __webpack_public_path__ + "img/van-home.c1b06e46.jpg";